import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";

const footerLinks = {
  company: [
    { key: "about", to: "/about" },
    { key: "contact", to: "/contact" },
  ],
  product: [
    { key: "billing", to: "/billing" },
    { key: "settings", to: "/billing" },
  ],
  legal: [
    { key: "terms", to: "/terms" },
    { key: "privacy", to: "/privacy" },
  ],
};

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer style={{ background: "#0d0d0d", borderTop: "1px solid #1e1e1e" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <Logo size="md" />
            <p className="text-xs mt-3 leading-relaxed max-w-[200px]" style={{ color: "#6b6b6b" }}>
              {t("footer.tagline")}
            </p>
          </div>

          {Object.entries(footerLinks).map(([section, links]) => (
            <div key={section}>
              <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: "#6b6b6b" }}>
                {t(`footer.sections.${section}`)}
              </p>
              <ul className="space-y-2.5">
                {links.map(({ key, to }) => (
                  <li key={key}>
                    <Link
                      to={to}
                      data-testid={`footer-link-${key}`}
                      className="text-sm transition-colors"
                      style={{ color: "#6b6b6b" }}
                      onMouseOver={e => (e.target.style.color = "#c084fc")}
                      onMouseOut={e => (e.target.style.color = "#6b6b6b")}
                    >
                      {t(`footer.links.${key}`)}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-6"
          style={{ borderTop: "1px solid #1a1a1a" }}>
          <p className="text-xs" style={{ color: "#6b6b6b" }}>
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </p>
          <p className="text-xs" style={{ color: "#6b6b6b" }}>
            {t("footer.builtWith")}
          </p>
        </div>
      </div>
    </footer>
  );
}
